/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  function setupBiorayKidsSummerLinkRewrite() {
    var oldBiorayKidsPath = '/collections/bioray-kids';
    var newBiorayKidsPath = '/collections/bioray-kids-summer';

    function rewriteBiorayKidsLink(link) {
      var rawHref = link.getAttribute('href');

      if (!rawHref || rawHref.charAt(0) === '#') {
        return;
      }

      try {
        var url = new URL(rawHref, window.location.origin);
        var isOldBiorayKidsCollection = url.pathname.replace(/\/$/, '') === oldBiorayKidsPath;

        if (!isOldBiorayKidsCollection || !/^https?:$/.test(url.protocol)) {
          return;
        }

        url.pathname = newBiorayKidsPath;
        link.setAttribute('href', getReplacementHref(rawHref, url));
      } catch (error) {
        // Ignore malformed href values so one bad CMS link does not block the rest.
      }
    }

    function getReplacementHref(rawHref, url) {
      var pathWithSuffix = url.pathname + url.search + url.hash;

      if (rawHref.indexOf('//') === 0) {
        return '//' + url.host + pathWithSuffix;
      }

      if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(rawHref)) {
        return url.protocol + '//' + url.host + pathWithSuffix;
      }

      return pathWithSuffix;
    }

    function rewriteBiorayKidsLinks(container) {
      if (!container.querySelectorAll) {
        return;
      }

      Array.prototype.forEach.call(container.querySelectorAll('a[href]'), rewriteBiorayKidsLink);
    }

    rewriteBiorayKidsLinks(document);

    var linkObserver = new MutationObserver(function(mutations) {
      Array.prototype.forEach.call(mutations, function(mutation) {
        if (mutation.type === 'attributes') {
          if (mutation.target.matches && mutation.target.matches('a[href]')) {
            rewriteBiorayKidsLink(mutation.target);
          }

          return;
        }

        Array.prototype.forEach.call(mutation.addedNodes, function(node) {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
          }

          if (node.matches && node.matches('a[href]')) {
            rewriteBiorayKidsLink(node);
          }

          rewriteBiorayKidsLinks(node);
        });
      });
    });

    linkObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true
    });
  }

  setupBiorayKidsSummerLinkRewrite();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
